import banner1Cn from "assets/Desktop/images/banner/banner 1 cn.png";
import banner1Turkey from "assets/Desktop/images/banner/banner 1 turkey.png";
import banner1En from "assets/Desktop/images/banner/banner 1.png";
import banner2Cn from "assets/Desktop/images/banner/banner 2 cn.png";
import banner2Turkey from "assets/Desktop/images/banner/banner 2 turkey.png";
import banner2En from "assets/Desktop/images/banner/banner 2.png";

import { GetPromotion, GetPromotionListResponse } from "./type";

const PROMOTIONS_BY_LANG: Record<
  string,
  Array<{
    id: string;
    bonus: string;
    wager: string;
    content: string;
    bonusAmount: string;
    turnover: string;
    image: string;
  }>
> = {
  tr: [
    {
      id: "1",
      bonus: "%100 Spor Hoş Geldin Bonusu",
      wager: "15",
      content:
        "İlk yatırımınıza özel Spor bahislerinde geçerli %100 hoş geldin bonusu kazanın. 15x çevrim şartı ile hemen katılın.",
      bonusAmount: "10000.00",
      turnover: "150000.00",
      image: banner1Turkey,
    },
    {
      id: "2",
      bonus: "%50 Canlı Casino Hoş Geldin Bonusu",
      wager: "10",
      content:
        "Canlı Casino oyunlarında geçerli %50 hoş geldin bonusu fırsatı! Gerçek krupiyeler ile kazanmaya başlayın. 10x çevrim şartı.",
      bonusAmount: "5000.00",
      turnover: "50000.00",
      image: banner2Turkey,
    },
  ],
  en: [
    {
      id: "1",
      bonus: "100% Sports Welcome Bonus",
      wager: "15",
      content:
        "Get a 100% welcome bonus on your first deposit for Sports betting up to 10,000 TRY. 15x turnover requirement.",
      bonusAmount: "10000.00",
      turnover: "150000.00",
      image: banner1En,
    },
    {
      id: "2",
      bonus: "50% Live Casino Welcome Bonus",
      wager: "10",
      content:
        "Enjoy a 50% bonus on Live Casino games with up to 5,000 TRY extra funds. 10x turnover requirement with real dealer tables.",
      bonusAmount: "5000.00",
      turnover: "50000.00",
      image: banner2En,
    },
  ],
  zh: [
    {
      id: "1",
      bonus: "100% 體育迎新紅利",
      wager: "15",
      content:
        "首次存款即可獲得 100% 體育專屬迎新紅利，最高 10,000 TRY，僅需 15 倍流水。",
      bonusAmount: "10000.00",
      turnover: "150000.00",
      image: banner1Cn,
    },
    {
      id: "2",
      bonus: "50% 真人視訊首存紅利",
      wager: "10",
      content:
        "真人娛樂場尊享 50% 迎新紅利，最高 5,000 TRY，體驗極致奢華真人荷官牌桌，10 倍流水。",
      bonusAmount: "5000.00",
      turnover: "50000.00",
      image: banner2Cn,
    },
  ],
};

export const retriveApi = {
  async getPromotionList(username: string, _payload?: GetPromotion) {
    const rawLng =
      localStorage.getItem("i18nLng") ||
      localStorage.getItem("syslang") ||
      "tr";
    const currentLang = rawLng.startsWith("zh")
      ? "zh"
      : rawLng.startsWith("vi")
        ? "en"
        : rawLng.startsWith("en")
          ? "en"
          : "tr";

    const promoItems =
      PROMOTIONS_BY_LANG[currentLang] || PROMOTIONS_BY_LANG["tr"];

    return {
      status: 0,
      msg: "Success",
      username: username || "tk88_member",
      data: promoItems.map((item) => ({
        id: item.id,
        bonus: item.bonus,
        wager: item.wager,
        web: item.image,
        mobile: item.image,
        content: item.content,
        button: true,
        date: "2026-09-01",
        bonusAmount: item.bonusAmount,
        turnover: item.turnover,
        status: "Active",
      })),
    } as GetPromotionListResponse;
  },
};
